<div class="mainContainer mt-5 d-flex flex-column align-items-center">
  <div class="vMax wrap">
    <div class="heroWrap">
      <h2 class="headingWL">Our Social  <span> Initiative</span></h2>
    </div>

    <div class="wrapper">
        <p class="vtext1" *ngFor="let item of data" > {{item}} </p>
    </div>
  </div>
</div>